export default __webpack_public_path__ + "static/media/avatar_56.f7df094a.png";